<template>
  <v-flex class="cat-list">
    <div v-for="(subCategory, i) in subCategories" :key="i" class="my-2">
      <p class="mb-0">
        <span class="sign display-12">></span>
        <nuxt-link
          :ref="`catItem`"
          :to="`jobs/subcat/${subCategory.id}`"
          class="black--text display-14 no-underline mr-1 cat-list-item"
          >{{ subCategory.name }}</nuxt-link
        >
      </p>
    </div>
  </v-flex>
</template>

<script>
export default {
  props: {
    subCategories: {
      type: [Object, Array],
      required: false,
      default: () => {},
    },
   
  },
}
</script>

<style lang="scss" scoped>
.cat-img {
  position: relative;
}

.cat-img .v-responsive {
  border-radius: 5px 5px 0 0;
  max-height: 115px;
  opacity: 0.5;
}

.cat-img .cat-jobs {
  font-size: 12px;
  position: absolute;
  z-index: 1;
  top: 5px;
  left: 5px;
  display: inline-flex;
  color: $primary;
  background: rgba(255, 255, 255, 0.8);
  padding: 2px 16px;
  border-radius: 13px;
}

</style>
